import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitStatus('submitting');

    try {
      const form = e.currentTarget;
      const formDataToSend = new URLSearchParams();
      
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('subject', formData.subject);
      formDataToSend.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d6pavrcddmmni7ck7v10', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => setSubmitStatus('idle'), 5000);
      } else {
        setSubmitStatus('error');
        setTimeout(() => setSubmitStatus('idle'), 5000);
      }
    } catch (error) {
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus('idle'), 5000);
    }
  };

  const contactInfo = [
    { icon: 'ri-map-pin-line', label: 'ADDRESS', value: 'Perball gjykates se apelit 14' },
    { icon: 'ri-building-line', label: 'CITY', value: 'DURRES' },
    { icon: 'ri-mail-line', label: 'ZIP CODE', value: '2001' },
    { icon: 'ri-global-line', label: 'COUNTRY', value: 'Albania' },
    { icon: 'ri-mail-send-line', label: 'EMAIL', value: 'contact@tafarucishpk.com' },
    { icon: 'ri-phone-line', label: 'PHONE', value: '+1 6402303267' },
  ];

  return (
    <section id="contact" className="py-24 bg-[#F8F9FA]">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-16">
          <h3 className="text-5xl font-bold text-black">Get In Touch</h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div className="space-y-8">
            <h4 className="text-2xl font-bold text-black mb-8">Contact Information</h4>
            <div className="space-y-8">
              {contactInfo.map((item, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-xl text-[#00D9FF]`}></i>
                  </div>
                  <div className="space-y-1">
                    <div className="text-xs font-bold text-[#718096] uppercase tracking-wider whitespace-nowrap">
                      {item.label}
                    </div>
                    <div className="text-lg font-medium text-black">
                      {item.value}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="pt-12 space-y-4">
              <div className="text-2xl font-bold text-black">TAFARUCI SH.P.K.</div>
              <div className="text-base text-[#718096]">Modern iOS Applications</div>
              <div className="text-sm text-[#A0AEC0] pt-8">
                © 2025 TAFARUCI SH.P.K. All rights reserved
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-10 shadow-xl">
            <h4 className="text-2xl font-bold text-black mb-8">Send Us a Message</h4>
            
            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-[#2D3748] mb-2 whitespace-nowrap">
                  Your Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00D9FF] focus:border-transparent outline-none transition-all text-sm"
                  placeholder="John Doe"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-[#2D3748] mb-2 whitespace-nowrap">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00D9FF] focus:border-transparent outline-none transition-all text-sm"
                  placeholder="john@example.com"
                />
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-[#2D3748] mb-2 whitespace-nowrap">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00D9FF] focus:border-transparent outline-none transition-all text-sm"
                  placeholder="How can we help?"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-[#2D3748] mb-2 whitespace-nowrap">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00D9FF] focus:border-transparent outline-none transition-all resize-none text-sm"
                  placeholder="Tell us about your inquiry..."
                />
                <div className="text-xs text-[#A0AEC0] mt-2 text-right">
                  {formData.message.length}/500 characters
                </div>
              </div>

              <button
                type="submit"
                disabled={submitStatus === 'submitting'}
                className="w-full bg-gradient-to-r from-[#00D9FF] to-[#0066FF] text-white font-semibold py-4 px-8 rounded-lg hover:shadow-xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {submitStatus === 'submitting' ? 'Sending...' : 'Send Message'}
              </button>

              {submitStatus === 'success' && (
                <div className="p-4 bg-green-50 border border-green-200 rounded-lg text-green-800 text-sm text-center">
                  Thank you! Your message has been sent successfully.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-800 text-sm text-center">
                  Sorry, there was an error sending your message. Please try again.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}